<template>
  <detailTemplate :classCustom="'detail-docs extend-detail'">
    <template #content>
      <div style="overflow: auto;">
        <div
          class="back-icon border-radius__50 clickable flex-row flex__center"
          @click="backListPage()"
        >
          <i class="el-icon-back font-size__large"></i>
        </div>
        <div class="header margin-bottom-10">
          <div
            style="color: #007aff"
            class="font-size__large font-weight__bold"
          >Lịch đăng ký phòng họp</div>
        </div>

        <FullCalendar
          :firstDay="1"
          :height="680"
          :schedulerLicenseKey="schedulerLicenseKey"
          :events="events"
          :plugins="calendarPlugins"
          :defaultView="defaultView"
          :minTime="minTime"
          :maxTime="maxTime"
          :titleFormat="titleFormat"
          :eventTimeFormat="eventTimeFormat"
          :buttonText="buttonText"
          :weekends="true"
          :allDaySlot="false"
          :displayEventEnd="true"
          :slotEventOverlap="false"
          :resourceLabelText="'Danh sách phòng'"
          :slotDuration="slotDuration"
          :resourceAreaWidth="'20%'"
          locale="vi"
        />
      </div>
    </template>
  </detailTemplate>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import timeGridPlugin from '@fullcalendar/timegrid';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import hanhchinhService from "../../../services/hanhchinhService";
import moment from "moment";
export default {
  name: "dkPhongHop-lichdangky",
  components: {
    VuePerfectScrollbar,
    FullCalendar,
    detailTemplate: () => import("../../common/detail.vue")
  },

  created() {
    let threeMonthAgo = moment(new Date()).add(-3, 'months').toDate().getTime();
    let threeMonthFuture = moment(new Date()).add(3, 'months').toDate().getTime();

    this.getCalendar(threeMonthAgo, threeMonthFuture);
  },

  data() {
    return {
      schedulerLicenseKey: "0262536596-fcs-1558600946",
      events: [],
      calendarPlugins: [timeGridPlugin],
      defaultView: "timeGridWeek",
      slotDuration: "00:30:00",
      minTime: "06:00:00",
      maxTime: "24:00:00",
      titleFormat: { year: "numeric", month: "long", day: "2-digit" },
      eventTimeFormat: {
        hour: "2-digit",
        minute: "2-digit",
        omitZeroMinute: false,
        meridiem: "narrow"
      },
      buttonText: {
        today: "Hôm nay",
        dayGridMonth: "Tháng",
        timeGridWeek: "Tuần",
        timeGrid: "Ngày"
      }
    };
  },
  methods: {
    backListPage() {
      this.$router.push({
        name:
          this.$route.name === "adminstration-regisRoomCalendar"
            ? `adminstration-index`
            : `adminstration-dx`
      });
    },
    getCalendar(startTime, endTime) {
      return hanhchinhService
        .getRegisRoomCalendar(startTime, endTime, 'PHONG_HOP')
        .then(response => {
          response.data.data.forEach(item => {
            var eventColors = [
              "#093145",
              "#107896",
              "#A6206A",
              "#C2571A",
              "#9A2617",
              "#378006",
              "#005E37",
              "#035066",
              "#673AB7"
            ];
            var color = eventColors[Math.floor(Math.random() * eventColors.length)];

            this.events.push({
              title: `${item.roomName}: ${item.note}`,
              start: moment(item.startTime).format("YYYY-MM-DDTHH:mm:ss"),
              end: moment(item.endTime).format("YYYY-MM-DDTHH:mm:ss"),
              durationEditable: false,
              startEditable: false,
              backgroundColor: color,
              borderColor: color,
              resourceId: item.roomName
            });
          });
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/adminstration/phonghop/PhongHop_Calendar.vue